(function () {
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(this, "score", 0);
        (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(this, "status", "idle");
        this.matrix = initialState;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var callback = function(number) {
                    return number !== 0;
                };
                for(var arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
                    var array = this.matrix[arrayIndex];
                    var additionalArray = array.filter(callback);
                    for(var i = 0; i < additionalArray.length; i++)if (additionalArray[i] === additionalArray[i + 1]) {
                        var add = additionalArray[i] * 2;
                        additionalArray[i] = add;
                        additionalArray[i + 1] = 0;
                        this.score += add;
                    }
                    var filteredArray = additionalArray.filter(callback);
                    while(filteredArray.length - 1 < array.length - 1)filteredArray.push(0);
                    this.matrix[arrayIndex] = filteredArray;
                }
                return this.matrix;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var callback = function(number) {
                    return number !== 0;
                };
                for(var arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++){
                    var array = this.matrix[arrayIndex];
                    var additionalArray = array.filter(callback);
                    for(var i = 0; i < additionalArray.length; i++){
                        var lastElem = additionalArray.length - i - 1;
                        if (additionalArray[lastElem] === additionalArray[lastElem - 1]) {
                            var add = additionalArray[lastElem] * 2;
                            additionalArray[lastElem] = add;
                            additionalArray[lastElem - 1] = 0;
                            this.score += add;
                        }
                    }
                    var filteredArray = additionalArray.filter(callback);
                    while(filteredArray.length - 1 < array.length - 1)filteredArray.unshift(0);
                    this.matrix[arrayIndex] = filteredArray;
                }
                return this.matrix;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(arrayIndex) {
                    var columnElements = [];
                    _this.matrix.forEach(function(array, index) {
                        return columnElements[index] = array[arrayIndex];
                    });
                    var filteredElements = columnElements.filter(callback);
                    for(var i = 0; i < filteredElements.length; i++)if (filteredElements[i] === filteredElements[i + 1]) {
                        var add = filteredElements[i] * 2;
                        filteredElements[i] = add;
                        filteredElements[i + 1] = 0;
                        _this.score += add;
                    }
                    var filteredArray = filteredElements.filter(callback);
                    while(filteredArray.length - 1 < _this.matrix[arrayIndex].length - 1)filteredArray.push(0);
                    for(var index = 0; index < _this.matrix.length; index++)_this.matrix[index][arrayIndex] = filteredArray[index];
                };
                var callback = function(number) {
                    return number !== 0;
                };
                for(var arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++)_loop(arrayIndex);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(arrayIndex) {
                    var columnElements = [];
                    _this.matrix.forEach(function(array, index) {
                        return columnElements[index] = array[arrayIndex];
                    });
                    var filteredElements = columnElements.filter(callback);
                    for(var i = filteredElements.length - 1; i > 0; i--)if (filteredElements[i] === filteredElements[i - 1]) {
                        var add = filteredElements[i] * 2;
                        filteredElements[i] = add;
                        filteredElements[i - 1] = 0;
                        _this.score += add;
                    }
                    var filteredArray = filteredElements.filter(callback);
                    while(filteredArray.length - 1 < _this.matrix[arrayIndex].length - 1)filteredArray.unshift(0);
                    for(var index = 0; index < _this.matrix.length; index++)_this.matrix[index][arrayIndex] = filteredArray[index];
                };
                var callback = function(number) {
                    return number !== 0;
                };
                for(var arrayIndex = 0; arrayIndex < this.matrix.length; arrayIndex++)_loop(arrayIndex);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.matrix;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                return [
                    this.addRandomElement(),
                    this.addRandomElement()
                ];
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.matrix = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
                return this;
            }
        },
        {
            key: "getRandomCoords",
            value: function getRandomCoords() {
                var row = Math.floor(Math.random() * 4);
                var column = Math.floor(Math.random() * 4);
                while(this.matrix[row][column] !== 0){
                    row = Math.floor(Math.random() * 4);
                    column = Math.floor(Math.random() * 4);
                }
                return [
                    row,
                    column
                ];
            }
        },
        {
            key: "addRandomElement",
            value: function addRandomElement() {
                return Math.random() < 0.1 ? 4 : 2;
            }
        },
        {
            key: "isMovePossible",
            value: function isMovePossible() {
                var matrixLength = this.matrix.length;
                var matrix = this.matrix;
                for(var row = 0; row < matrixLength; row++)for(var column = 0; column < matrixLength; column++){
                    if (column < matrixLength - 1 && matrix[row][column] === matrix[row][column + 1] || row < matrixLength - 1 && matrix[row][column] === matrix[row + 1][column]) return true;
                }
                return false;
            }
        },
        {
            key: "isPlaying",
            value: function isPlaying() {
                var zeros = this.matrix.filter(function(array) {
                    return array.includes(0);
                });
                var win = this.matrix.flat().includes(2048);
                if (!zeros.length && !this.isMovePossible()) this.status = "lose";
                if (win) this.status = "win";
                return this;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "isGameActive", false);
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports([
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
]);
var $197cd56b15c33885$var$container = document.querySelector(".container");
var $197cd56b15c33885$var$gameHeader = $197cd56b15c33885$var$container.querySelector(".game-header");
var $197cd56b15c33885$var$controls = $197cd56b15c33885$var$gameHeader.querySelector(".controls");
var $197cd56b15c33885$var$button = $197cd56b15c33885$var$controls.querySelector("button.button");
var $197cd56b15c33885$var$gameScore = $197cd56b15c33885$var$controls.querySelector(".game-score");
var $197cd56b15c33885$var$tBody = $197cd56b15c33885$var$container.querySelector("tbody");
var $197cd56b15c33885$var$arrayOfTr = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$tBody.querySelectorAll("tr"));
var $197cd56b15c33885$var$messages = $197cd56b15c33885$var$container.querySelector(".message-container");
var $197cd56b15c33885$var$startMessage = $197cd56b15c33885$var$messages.querySelector(".message-start");
var $197cd56b15c33885$var$loseMessage = $197cd56b15c33885$var$messages.querySelector(".message-lose");
var $197cd56b15c33885$var$winMessage = $197cd56b15c33885$var$messages.querySelector(".message-win");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        var values = $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startMessage.classList.add("hidden");
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.textContent = "Restart";
        values.forEach(function(value) {
            var _game_getRandomCoords = (0, $efec029548ccee7f$export$71511d61b312f219)($197cd56b15c33885$var$game.getRandomCoords(), 2), row = _game_getRandomCoords[0], column = _game_getRandomCoords[1];
            var cell = $197cd56b15c33885$var$arrayOfTr[row].children[column];
            cell.textContent = value;
            cell.classList.add("field-cell--".concat(value));
            $197cd56b15c33885$var$game.matrix[row][column] = value;
        });
    } else {
        (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$game.getState()).forEach(function(array, index) {
            array.forEach(function(number, i) {
                var cell = $197cd56b15c33885$var$arrayOfTr[index].children[i];
                cell.textContent = "";
                cell.className = "field-cell";
                if (number > 0) cell.classList.remove("field-cell--".concat(number));
            });
        });
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
        $197cd56b15c33885$var$startMessage.classList.remove("hidden");
        $197cd56b15c33885$var$button.classList.remove("restart");
        $197cd56b15c33885$var$button.classList.add("start");
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$gameScore.textContent = "".concat($197cd56b15c33885$var$game.getScore());
    }
});
document.addEventListener("keydown", function(EVENT) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var key = EVENT.key;
    var prevState = JSON.stringify($197cd56b15c33885$var$game.getState());
    if (key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    var nextState = JSON.stringify($197cd56b15c33885$var$game.getState());
    if (prevState !== nextState) {
        var randomElem = $197cd56b15c33885$var$game.addRandomElement();
        if ($197cd56b15c33885$var$game.matrix.flat().includes(0)) {
            var _game_getRandomCoords = (0, $efec029548ccee7f$export$71511d61b312f219)($197cd56b15c33885$var$game.getRandomCoords(), 2), row = _game_getRandomCoords[0], column = _game_getRandomCoords[1];
            $197cd56b15c33885$var$game.matrix[row][column] = randomElem;
            var cell = $197cd56b15c33885$var$arrayOfTr[row].children[column];
            cell.textContent = randomElem;
            cell.classList.add("field-cell--".concat(randomElem));
        }
        $197cd56b15c33885$var$game.isPlaying();
        if ($197cd56b15c33885$var$game.matrix.flat().includes(0)) {
            var _game_getRandomCoords1 = (0, $efec029548ccee7f$export$71511d61b312f219)($197cd56b15c33885$var$game.getRandomCoords(), 2), row1 = _game_getRandomCoords1[0], column1 = _game_getRandomCoords1[1];
            $197cd56b15c33885$var$game.matrix[row1][column1] = randomElem;
            var cell1 = $197cd56b15c33885$var$arrayOfTr[row1].children[column1];
            cell1.textContent = randomElem;
            cell1.classList.add("field-cell--".concat(randomElem));
        }
        $197cd56b15c33885$var$game.isPlaying();
        var matrix = $197cd56b15c33885$var$game.getState();
        matrix.forEach(function(array, rowIndex) {
            array.forEach(function(number, colIndex) {
                var cell = $197cd56b15c33885$var$arrayOfTr[rowIndex].children[colIndex];
                cell.textContent = "";
                cell.className = "field-cell";
                if (number > 0) {
                    cell.textContent = number;
                    cell.classList.add("field-cell--".concat(number));
                }
            });
        });
        if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
        if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    }
    $197cd56b15c33885$var$gameScore.textContent = "".concat($197cd56b15c33885$var$game.getScore());
});

})();
//# sourceMappingURL=index.a9c1a38b.js.map
